import { Action, createReducer, on } from '@ngrx/store';
import { uiActions } from './ui.actions';

export const UI_FEATURE_KEY = 'ui';

export interface UIState {
  sidebarCollapsed: boolean;
}

export const initialUIState: UIState = {
  sidebarCollapsed: false,
};

const reducer = createReducer(
  initialUIState,
  on(uiActions.setSidebarCollapsed, (state, { collapsed }) => ({
    ...state,
    sidebarCollapsed: collapsed,
  }))
);

export function uiReducer(state: UIState | undefined, action: Action) {
  return reducer(state, action);
}
